import { Button, DialogActions, DialogContentText, Divider, Typography } from '@material-ui/core';
import { Dispatch } from '@reduxjs/toolkit';
import React, { Component, Fragment } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { AppDispatch } from 'store';
import { dialogClose } from 'store/dialog/dialog.actions';
import { CustomDialogButtonContainer, CustomDialogContent } from '../CustomDialog.styled';

interface IDispatchProps {
  dialogClose: () => AppDispatch;
}

type PropType = IDispatchProps & WithTranslation;

class CancelUnsuccessful extends Component<PropType> {
  private handleClose = (): void => {
    const { dialogClose } = this.props;
    dialogClose();
  };

  render(): JSX.Element {
    const { t } = this.props;
    return (
      <Fragment>
        <CustomDialogContent>
          <DialogContentText>
            <Typography component="span" color="textPrimary">
              {t('modal.cancelUnsuccessfulAlert1')}
            </Typography>
            <br />
            <Typography component="span" color="textPrimary">
              {t('modal.cancelUnsuccessfulAlert2')}
            </Typography>
          </DialogContentText>
        </CustomDialogContent>
        <Divider />
        <DialogActions>
          <CustomDialogButtonContainer>
            <Button color="secondary" variant="contained" onClick={this.handleClose}>
              {t('modal.ok')}
            </Button>
          </CustomDialogButtonContainer>
        </DialogActions>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AppDispatch>): IDispatchProps => ({
  dialogClose: (): AppDispatch => dispatch(dialogClose()),
});

export default connect(null, mapDispatchToProps)(withTranslation()(CancelUnsuccessful));
